// Action Type
// Search by phone number Contact Person Lookup
export const SEARCH_CONTACT_PERSON_LOOKUP_BY_PHONE_NUMBER =
  "SEARCH_CONTACT_PERSON_LOOKUP_BY_PHONE_NUMBER";
export const SEARCH_CONTACT_PERSON_LOOKUP_BY_PHONE_NUMBER_SUCCESS =
  "SEARCH_CONTACT_PERSON_LOOKUP_BY_PHONE_NUMBER_SUCCESS";
export const SEARCH_CONTACT_PERSON_LOOKUP_BY_PHONE_NUMBER_ERROR =
  "SEARCH_CONTACT_PERSON_LOOKUP_BY_PHONE_NUMBER_ERROR";
